"use client";

import { Icon } from "@/components/ui/icon";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import type { Agent } from "@/lib/types";
import { cn } from "@/lib/utils";
import { useTranslations } from "next-intl";

export function AgentVerifiedBadge({
  agent,
  displayIfNotVerified = true,
}: {
  agent: Agent;
  displayIfNotVerified?: boolean;
}) {
  const t = useTranslations();

  if (!agent.isVerified && !displayIfNotVerified) {
    return null;
  }

  return (
    <TooltipProvider delayDuration={0}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Icon
            icon="CheckVerified2Solid"
            className={cn("shrink-0", {
              "text-theme-blue": agent.isVerified,
              "text-muted-foreground opacity-30": !agent.isVerified,
            })}
          />
        </TooltipTrigger>

        <TooltipContent>
          {t(
            agent.isVerified
              ? "saas.agentSmall.verified"
              : "saas.agentSmall.notVerified",
          )}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
